import Button, { type ButtonProps } from '@mui/material/Button'
import { MUTED_TEXT_COLOR } from '../theme'

/**
 * Botão secundário (ex: "Cancelar") com affordance visível — borda e fundo
 * ligeiramente diferenciados — mas claramente inferior em hierarquia ao
 * botão primário (`variant="contained"`, azul).
 *
 * Substitui o padrão anterior `variant="text" sx={{ color: 'text.secondary' }}`,
 * que não tinha borda nem fundo e ficava demasiado discreto ao lado do
 * botão primário.
 */
export default function SecondaryButton({ sx, ...props }: ButtonProps) {
    return (
        <Button
            variant="outlined"
            sx={{
                color: MUTED_TEXT_COLOR,
                borderColor: '#D1D5DB',
                bgcolor: '#F9FAFB',
                fontWeight: 600,
                '&:hover': {
                    bgcolor: '#F3F4F6',
                    borderColor: '#9CA3AF',
                },
                '&.Mui-disabled': {
                    borderColor: '#E5E7EB',
                },
                ...sx,
            }}
            {...props}
        />
    )
}
